import React, { useState } from "react";
import { Link } from "react-router-dom";
import pickloadicon from "../../images/pickloadicon.png";
import pickloadtitle from "../../images/pickloadtitle.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="w-full bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* LEFT LOGO */}
        <Link to="/" className="flex items-center gap-2">
          <img src={pickloadicon} alt="icon" className="w-8 h-8" />
          <img src={pickloadtitle} alt="title" className="h-6" />
        </Link>

        {/* DESKTOP MENU */}
        <div className="hidden md:flex items-center gap-8">
          <a
            href="https://www.youtube.com/@pickloadlogistics7714"
            target="_blank"
            rel="noreferrer"
            className="text-gray-700 hover:text-black transition"
          >
            Learn
          </a>

          <Link to="/faqs" className="text-gray-700 hover:text-black transition">
            FAQs
          </Link>

          <Link to="/referral_login" className="text-gray-700 hover:text-black transition">
            Refer a friend
          </Link>

          <Link to="/downloadapp">
            <button className="bg-green-900 text-white px-4 py-2 rounded-lg hover:bg-green-800 transition">
              Sign Up Now
            </button>
          </Link>
        </div>

        {/* HAMBURGER */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden flex flex-col gap-1.5"
        >
          <span className={`w-6 h-0.5 bg-black transition ${isOpen ? "rotate-45 translate-y-1.5" : ""}`}></span>
          <span className={`w-6 h-0.5 bg-black transition ${isOpen ? "opacity-0" : ""}`}></span>
          <span className={`w-6 h-0.5 bg-black transition ${isOpen ? "-rotate-45 -translate-y-1.5" : ""}`}></span>
        </button>
      </div>

      {/* MOBILE MENU (ANIMATED DROPDOWN) */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out bg-white border-t border-gray-200 ${
          isOpen ? "max-h-96 py-4" : "max-h-0 py-0"
        }`}
      >
        <div className="flex flex-col px-6 gap-4">

          <a
            href="https://www.youtube.com/@pickloadlogistics7714"
            target="_blank"
            rel="noreferrer"
            className="text-gray-700 hover:text-black transition"
            onClick={() => setIsOpen(false)}
          >
            Learn
          </a>

          <Link
            to="/faqs"
            className="text-gray-700 hover:text-black transition"
            onClick={() => setIsOpen(false)}
          >
            FAQs
          </Link>

          <Link
            to="https://referral.pickload.ng/"
            target="_blank"
            rel="noreferrer"
            className="text-gray-700 hover:text-black transition"
            onClick={() => setIsOpen(false)}
          >
            Refer a friend
          </Link>

          <Link to="/downloadapp" onClick={() => setIsOpen(false)}>
            <button className="w-full bg-green-900 text-white py-2 rounded-lg hover:bg-green-800 transition">
              Sign Up Now
            </button>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;